import { useRequest } from 'ahooks';
import { atom, useSetAtom } from 'jotai';

import { query_user_daygold_v2 } from '@/api/hall';
import { modalStore } from '@/stores/modal';

interface DailyItem {
  status: 'disabled' | 'received' | '' | 'expired';
  amount: number;
}

interface DailyConfig {
  config: number[];
  config_status: number[];
  is_expire: boolean;
  need_adjust: boolean;
  take_info: DailyTakeinfo;
}

/**每日登录奖金弹窗列表 */
export const dailyConfigAtom = atom<DailyItem[]>([
  { status: 'disabled', amount: 0 },
  { status: 'disabled', amount: 0 },
  { status: 'disabled', amount: 0 },
  { status: 'disabled', amount: 0 },
  { status: 'disabled', amount: 0 },
  { status: 'disabled', amount: 0 },
  { status: 'disabled', amount: 0 }
]);
export const dailyNeedAdjustAtom = atom(false);
/** 原始值 */
export const dailyConfigInfo = atom<DailyConfig>();

interface DailyTakeinfo {
  cur_day_index: number;
  is_need_pay: number;
  is_take_today: number;
  judge_flow: number;
  next_take_timer: number;
  userid: number;
}
export const dailyConfigTakeinfoAtom = atom<DailyTakeinfo>();

/**每日登录奖金领取信息 */
export const currentDailyInfoAtom = atom(get => {
  const config = get(dailyConfigTakeinfoAtom);
  const configList = get(dailyConfigAtom);
  const currentConfig = configList?.[config?.cur_day_index || 0] || {};
  return {
    ...config,
    ...currentConfig
  };
});

export const useDailyModalStore = () => {
  const setDailyConfigList = useSetAtom(dailyConfigAtom);
  const setDailyConfigTakeinfo = useSetAtom(dailyConfigTakeinfoAtom);
  const setDailyNeedAdjust = useSetAtom(dailyNeedAdjustAtom);
  const setDailyConfigInfo = useSetAtom(dailyConfigInfo);
  const { runAsync: getDaygold } = useRequest(query_user_daygold_v2, {
    manual: true,
    onSuccess: data => {
      const status = ['disabled', 'received', '', 'expired'];
      const { config = [], config_status = [], take_info = {}, need_adjust = false } = data;
      setDailyConfigList(
        config.map((amount, i) => ({
          status: status[config_status[i]],
          amount: amount
        }))
      );
      setDailyConfigTakeinfo(take_info);
      setDailyNeedAdjust(need_adjust);
      setDailyConfigInfo(data);
      modalStore.setDailyConfig(take_info, config, config_status);
    }
  });

  return [getDaygold];
};
